import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { AddressViewModel } from '../../../models/Entities/Person/Address/AddressModels';

// store
import * as PersonAddressesStore from '../../../redux/middleware/PersonAddresses.Middleware';

export interface IProps {
  PersonId: number;
}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  failOnLoading: boolean | undefined;
  isDeleting: boolean | undefined;
  failOnDeleting: boolean | undefined;
  error: ErrorType | undefined;
  addresses: AddressViewModel[];
}

interface DispatchProps {
  GetAddressesByPersonId: typeof PersonAddressesStore.actionCreators.GetAddressesByPersonId;
  DeleteAddress: typeof PersonAddressesStore.actionCreators.DeleteAddress;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonAddresses?.isLoadingAll,
  isLoadingSuccessfully: state.PersonAddresses?.successLoadingAll,
  failOnLoading: state.PersonAddresses?.failOnLoadingAll,
  isDeleting: state.PersonAddresses?.isDeletingOne,
  failOnDeleting: state.PersonAddresses?.failOnDeletingOne,
  error: state.PersonAddresses?.error,
  addresses: (state.PersonAddresses?.list ?? []).filter(
    (item: AddressViewModel) => item.personId === ownProps.PersonId
  ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonAddressesStore.actionCreators
};
